import ReactDOM from 'react-dom';
import App from './App';
ReactDOM.render(<App></App>,document.querySelector("#root"));